import type { PalletLoadTypeListResponse } from './api';

export const normalizePalletLoadTypeList = (list: PalletLoadTypeListResponse): { label: string; value: string }[] => {
  if (!list) {
    return [];
  }
  return list.map((row) => ({
    label: row.text,
    value: row.value,
  }));
};
